import FingerprintJS from '@fingerprintjs/fingerprintjs';

export const getDeviceFingerprint = async (): Promise<string> => {
  // 1. Vérifier si on a déjà un ID stocké localement
  const storedFingerprint = localStorage.getItem('device_fingerprint');

  if (storedFingerprint) {
    return storedFingerprint;
  }

  // 2. Sinon, générer un nouvel ID
  const fp = await FingerprintJS.load();
  const result = await fp.get();

  // 3. Le stocker pour les prochaines fois
  localStorage.setItem('device_fingerprint', result.visitorId);
  
  return result.visitorId;
};
